// extracted by mini-css-extract-plugin
export default {"Pic":"rsePic_Pic__smH-P"};